import React, {  useEffect, useState } from "react";
import { Tabs, Tab, Box, Typography, AppBar } from "@mui/material";
import { useLocation } from "react-router-dom";
import OverView from "./OverView";
import UserDetails from "./UserDetails";
import EvDetails from "./EvDetails";
import IotDetails from "./IotDetails";

interface TabPanelProps {
  children?: React.ReactNode;
  dir?: string;
  index: number;
  value: number;
}
// Component for rendering tables


const MultiTableTabs = () => {
  const location = useLocation();
  const initialTabIndex = location.state?.tabIndex;

  const [tabIndex, setTabIndex] = useState<number>(initialTabIndex ?? 0);

  const handleTabChange = (event: any, newValue: any) => {
    setTabIndex(newValue);
  };
  useEffect(() => {
    if (initialTabIndex !== undefined && initialTabIndex >= 0 && initialTabIndex <= 3) {
      setTabIndex(initialTabIndex);
    } else {
      setTabIndex(0); // Ensuring "Overview" opens by default on refresh
    }
  }, [initialTabIndex]);
  

  function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  
  function a11yProps(index: number) {
    return {
      id: `full-width-tab-${index}`,
      'aria-controls': `full-width-tabpanel-${index}`,
    };
  }
  
  return (
    <div>
       
    <div className="px-10">
   
        
      <Box sx={{ bgcolor: 'background.paper', width: '100%' }}>
      <AppBar position="static" style={{backgroundColor:'transparent', boxShadow:'none'}}>
          <Tabs
            value={tabIndex}
            onChange={handleTabChange}
            variant="fullWidth"
            centered
            TabIndicatorProps={{
              style: {
                backgroundColor: "#06B681", // Underline color
                fontWeight: "bold",
                color: "#06B681",
              },
            }}
            sx={{
              "& .MuiTab-root": {
                textTransform: "none",
                fontWeight: "semibold",
                color: "#06B681",
                fontSize: "20px",
                borderBottom: "4px solid #ccc", // Default grey border bottom for all tabs
              },
              "& .Mui-selected": {
                fontWeight: "bold",
                color: "#06B681",
                borderBottom: "4px solid #06B681 !important", // Green bottom border for selected tab
              },
            }}
          >
            <Tab {...a11yProps(0)} label="Overview" />
            <Tab {...a11yProps(1)} label="User Details" />
            <Tab {...a11yProps(2)} label="EV Details" />
            <Tab {...a11yProps(3)} label="IOT Details" />
          </Tabs>
       </AppBar>
       
        {/* Fleet Daily Summary Report Tab */}
        
          <TabPanel value={tabIndex} index={0}>
        <OverView/>
          </TabPanel>

          {/* GPS Report Tab */}
          <TabPanel value={tabIndex} index={1}>
          <UserDetails/>
         
          </TabPanel>

          <TabPanel value={tabIndex} index={2}>
          <EvDetails/>
          </TabPanel>
          <TabPanel value={tabIndex} index={3}>
         <IotDetails/>
          </TabPanel>
        </Box>
    </div>
    </div>
  );
};

export default MultiTableTabs;
